import type { FaireProductEntity } from "../../entity_types/product";

export const p_yecy74gq69: FaireProductEntity = {
  token: "p_yecy74gq69",
  type: "product",
  name: "Happy Dots Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/2818055da7861aa943c548867efac200f4cbc01c255c9778955c620e916523ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f44a97b21c69772a8091c83951805ae1cc858039a409aff7886ead503f0d1cfe.jpeg",
    "https://cdn.faire.com/fastly/aa94abd5c22fd9edd5a679e6d52201da22e7e163e5de40cfd436e27ed7196e29.jpeg"
  ],
  priceDollars: 8,
  description: "A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be \"well-edited\" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:16.577Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
